import { AppRoot } from '@vkontakte/vkui';
import { PropsWithChildren } from 'react';

export const AppWrapper = (props: PropsWithChildren) => {
	return <AppRoot>{props.children}</AppRoot>;
};
